export type ThinkingPost = {
  slug: string;
  title: string;
  deck: string;
  status: 'ready' | 'draft';
  theme: string;
};

export const thinkingNotes: ThinkingPost[] = [
  {
    slug: 'i-like-hard-problems',
    title: 'I Like Hard Problems',
    deck: 'The useful ones rarely arrive clean. They need structure, patience, and the nerve to keep moving when the first answer is not enough.',
    status: 'ready',
    theme: 'Judgment'
  },
  {
    slug: 'why-i-built-a-software-factory',
    title: 'Why I Built a Software Factory',
    deck: 'Speed is easy to admire. Trustworthy execution is harder: requirements, review, evidence, and the discipline to improve the system itself.',
    status: 'ready',
    theme: 'Execution'
  },
  {
    slug: 'ai-that-has-to-explain-itself',
    title: 'AI That Has to Explain Itself',
    deck: 'The closer AI gets to consequential decisions, the more it needs traceability, humility, and a human chain of accountability.',
    status: 'ready',
    theme: 'AI Governance'
  },
  {
    slug: 'the-off-grid-systems-lab',
    title: 'The Off-Grid Systems Lab',
    deck: 'A practical laboratory for energy, automation, load behavior, and the habits that make resilient systems easier to operate.',
    status: 'ready',
    theme: 'Resilience'
  },
  {
    slug: 'from-idea-to-operating-system',
    title: 'From Idea to Operating System',
    deck: 'A recurring pattern: take the idea seriously enough to give it structure, then keep improving it until it works in the real world.',
    status: 'ready',
    theme: 'Systems'
  }
];
